import React, { useState  , useEffect } from 'react';
import Select from 'react-select';
import { formSelect } from './styles';

import styles from './CustomSelect.module.scss';

export default function CustomSelect({
    defaultValue ,
    label ,
    options,
    isMulti,
    isClearable ,
    withErrors ,
    error ,
    handleChange ,
    value, 
    placeholder }) {

  const [ selected , setSelected ] = useState(defaultValue);

  useEffect(() => {
    setSelected(value)
  }, [value])

  function onChange(val) {
    setSelected(val);
    handleChange(val);
  }

  return (
    <div className={styles.select}>
      {label && <label>{label}</label>}
      <Select
        styles={formSelect}
        options={options}
        value={selected}
        isClearable={isClearable ? true : false }
        isMulti={isMulti ? true : false }
        placeholder={placeholder ? placeholder : "Séléctionner"}
        onChange={(val) => onChange(val)}
        />
      {withErrors && <p className={styles['error-message']}>{error && error}</p>}
    </div>
  )
}
